import { computed } from 'mobx'
import BaseStore from '@store/table'
import Api from '@api/xi_feng/case'

class Store extends BaseStore {
  id

  @computed
  get len() {
    return this.$list.length
  }

  @computed
  get ids() {
    return this.$list.map(item => item.work_id)
  }

  $listApi = Api.getRelationImg
  $getParams = () => {
    return {
      sample_id: this.id,
      ...this.$params
    }
  }

  reOrder = async (index, type) => {
    if (index === 0 && (!type || type === 'top')) {
      return
    }
    if (index === this.len - 1 && type === 'dest') {
      return
    }
    const id = this.$list[index].id
    let before_id = ''
    if (type === 'desc') {
      before_id = this.$list[index + 1].id
    } else if (type === 'top') {
      before_id = 0
    } else {
      if (index >= 2) {
        before_id = this.$list[index - 2].id
      } else {
        before_id = 0
      }
    }
    const { success } = await Api.reOrder({ id, before_id })
    if (success) {
      this.$getList(1)
    }
  }

  cancelRelation = async id => {
    const { success } = await Api.cancelRelation({
      sample_id: this.id,
      work_id: id
    })
    if (success) {
      this.$getList(1)
    }
  }
}

export default new Store()
